import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { ExportTableComponent } from '@shared/components/export-table';
import { InfoBlockDetail } from '@shared/components/info-block-datasource';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxFileDragDropModule } from 'ngx-file-drag-drop';
import {
  ButtonComponent,
  DeleteDialog,
  DialogCancelComponent,
  DialogDefaultComponent,
  FotoGaleriaComponent,
  HeaderComponent,
  InfoBlock,
  InputFilterComponent,
  LogoComponent,
  MultipleInfoBlock,
  PaginatorIntl,
  SelectorCheckboxFilterComponent,
  SubtitleComponent,
  TableComponent,
  TitleComponent
} from './components';
import { ClickOutsideDirective } from './directives';
import { InputComponent, InputFileComponent, MultipleSelecterComponent, SelecterComponent } from './forms';
import { MaterialAngularShared } from './material-angular-shared.module';
import { PhonePipe } from './pipes';
import {EmpresasLabelPipe} from "@shared/pipes/empresas-label.pipe";
import {MessagesPipe} from "@shared/pipes/messages.pipe";
import {TableFilterInputComponent} from "@shared/components/table-filter-input/table-filter-input.component";
import {DateRangeFilterComponent} from "@shared/date-range-filter";

@NgModule({
  imports: [
    InputComponent,
    InputFilterComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialAngularShared,
    NgxFileDragDropModule,
    HighchartsChartModule
  ],
  declarations: [
    ButtonComponent,
    DeleteDialog,
    DialogCancelComponent,
    DialogDefaultComponent,
    HeaderComponent,
    LogoComponent,
    TableComponent,
    SelectorCheckboxFilterComponent,
    TitleComponent,
    SubtitleComponent,
    ClickOutsideDirective,
    SelecterComponent,
    MultipleSelecterComponent,
    InfoBlock,
    MultipleInfoBlock,
    InfoBlockDetail,
    ExportTableComponent,
    InputFileComponent,
    PhonePipe,
    MessagesPipe,
    EmpresasLabelPipe,
    TableFilterInputComponent,
    FotoGaleriaComponent,
    DateRangeFilterComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialAngularShared,
    InputComponent,
    ButtonComponent,
    DeleteDialog,
    HeaderComponent,
    LogoComponent,
    TableComponent,
    SelectorCheckboxFilterComponent,
    TitleComponent,
    SubtitleComponent,
    CommonModule,
    ClickOutsideDirective,
    SelecterComponent,
    MultipleSelecterComponent,
    InfoBlock,
    MultipleInfoBlock,
    InfoBlockDetail,
    ExportTableComponent,
    InputFilterComponent,
    InputFileComponent,
    HighchartsChartModule,
    MessagesPipe,
    EmpresasLabelPipe,
    TableFilterInputComponent,
    FotoGaleriaComponent,
    DateRangeFilterComponent
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntl
    }
  ]
})
export class SharedModule {}
